<template>
  <div id="app">
    <router-view />
    <iframe :src="authUrl" class="my-iframe" id="myIframe" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      authUrl: window.location.origin + "/review/authIframe/index.html"
    };
  },
  mounted() {
    // 判断当前浏览器回话有没有用户登录
    var ifr = document.getElementById("myIframe");
    var ifrw = ifr.contentWindow ? ifr.contentWindow : ifr.contentDocument ? ifr.contentDocument.document : ifr.contentDocument;
    window.onload = function () {
      ifrw.postMessage("来自父窗口的消息", window.location.origin + "/review/authIframe/index.html");
    };
    window.addEventListener("message", data => {
      if (data.data.isLoaded) {
        console.log(444)
        console.log(data)
        console.log(data.data.isLoaded)
        let redirect_uri = window.location.origin + "/review/authIframe/index.html";
        var urlOld = `${this.$store.state.config.OPEN_API_URL}/authApi/auth/authorize?client_id=${this.$store.state.config.BASE_CLIENT_ID}&response_type=code&redirect_uri=${redirect_uri}`;
        var urlNew = `${this.$store.state.config.OPEN_API_URL}/oauth2/v1/connect/authorize?grant_type=authorization_code&response_type=code&client_id=${this.$store.state.config.BASE_CLIENT_ID}&state=0.9821429542035236&redirect_uri=${redirect_uri}`;
        console.log(123)
        console.log(this.$store.state.config)
        console.log(this.$store.state.config.isNewflat)
        console.log(this.$store.state.config.isNewflat == 'true')
        console.log(this.$store.state.config.isNewflat == true)
        console.log(this.$store.state.config.isNewflat == 'true' || this.$store.state.config.isNewflat == true)
        let _src = this.$store.state.config.isNewflat == 'true' ? urlNew : urlOld;
        console.log(_src)
        document.getElementById("myIframe").setAttribute("src", _src);
      } else if (data.data.isTicket) {
        this.$store.dispatch('login', { code: data.data.isTicket })
      }
    });
  }
};
</script>

<style>
.my-iframe {
  width: 0;
  height: 0;
  position: fixed;
  top: -200px;
}

body,
div,
ol,
ul,
li,
p,
dl,
dt,
dd,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}

ol,
ul,
li {
  list-style: none;
}

a {
  text-decoration: none;
}

body {
  background: #f5f7fa;
}

.content {
  min-height: 760px;
  margin: 20px;
  padding: 20px;
  background: #fff;
}

.cont-title {
  padding-left: 10px;
  position: relative;
}

.cont-title::after {
  content: "";
  width: 2px;
  height: 16px;
  background: #4c95fb;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
}

.el-table th.el-table__cell {
  background: #edf4fe !important;
}

.el-message {
  z-index: 9999 !important;
}
</style>
<style lang="less">
.new-scrollbar {
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-thumb {
    margin-right: -2px;
    border-radius: 5px;
    background-color: hsla(220, 4%, 58%, 0.3);
  }
}

* {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue